// Where the edge API lives.
//
//  - On the website this is a plain relative '/api' (Cloudflare Pages
//    Functions, same origin) — nothing changes there.
//  - Inside the native Capacitor shell the app is served from the
//    capacitor:// scheme, so a relative path would resolve against the local
//    asset bundle and 404. There we point at the deployed site instead.
//
// VITE_API_BASE_URL always wins, so an external backend can still be used.

/** Origin of the deployed web app (used only by the native shell). */
export const SITE_ORIGIN = 'https://777player.app'

/** True when running inside the Capacitor (iOS/Android) shell. */
export const isNativeShell =
  typeof window !== 'undefined' && window.location.protocol === 'capacitor:'

const configured = (import.meta.env.VITE_API_BASE_URL || '').trim()

/** Base URL for the API — relative on the web, absolute in the native shell. */
export const API_BASE =
  configured || (isNativeShell ? `${SITE_ORIGIN}/api` : '/api')

/**
 * Resolve an API path that may be root-relative (e.g. '/api/tbstream?...')
 * to something the current runtime can actually fetch.
 */
export function apiUrl(path: string): string {
  if (!path.startsWith('/')) return path
  if (!isNativeShell) return path
  return `${SITE_ORIGIN}${path}`
}
